export class RentalServiceApi {
  constructor(api, rentalTransaction) {
    this.api = api;
    this.rentalTransaction = rentalTransaction;
  }
  
  async addServices({orgId, trxId, aggServiceItems}) {
    for(let asi of aggServiceItems) {
      await this.rentalTransaction.addService({orgId, trxId, id: asi.available.id});
    }
  }

  async removeServices({orgId, trxId, aggServiceItems}) {
    for(let asi of aggServiceItems) {
      await this.rentalTransaction.deleteService({orgId, trxId, id: asi.inTransaction.id});
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/RentalServiceApi.js